
import { Vue, Component } from 'vue-property-decorator'
import IconInShape from '~/components/common/icon/IconInShape.vue'

@Component({
  name: 'BackRoundCtrl',
  components: {
    IconInShape
  }
})
export default class BackRoundCtrl extends Vue {}
